const FILE_TYPE_LABELS: ReadonlyMap<string, string> = new Map([
  ['jpg',  'Image'],
  ['jpeg', 'Image'],
  ['png',  'Image'],
  ['gif',  'Image'],
  ['tiff', 'Image'],
  ['bmp',  'Image'],
  ['svg',  'Image'],
  ['webp', 'Image'],

  ['pdf',  'Document PDF'],

  ['doc',  'Document Word'],
  ['docx', 'Document Word'],
  ['odt',  'Document OpenDocument'],

  ['xls',  'Tableur Excel'],
  ['xlsx', 'Tableur Excel'],
  ['ods',  'Tableur OpenDocument'],

  ['ppt',  'Présentation PowerPoint'],
  ['pptx', 'Présentation PowerPoint'],
  ['odp',  'Présentation OpenDocument'],

  ['mp3',  'Fichier audio'],
  ['wav',  'Fichier audio'],
  ['ogg',  'Fichier audio'],
  ['m4a',  'Fichier audio'],
  ['flac', 'Fichier audio'],
  ['weba', 'Fichier audio'],

  ['mp4',  'Fichier vidéo'],
  ['webm', 'Fichier vidéo'],
  ['ogv',  'Fichier vidéo'],
  ['mov',  'Fichier vidéo'],
  ['avi',  'Fichier vidéo'],
  ['wmv',  'Fichier vidéo'],

  ['zip',  'Archive'],
  ['tar',  'Archive'],
  ['gz',   'Archive'],
  ['rar',  'Archive'],
  ['7z',   'Archive'],
]);

export function getFileTypeLabel(extension: string): string {
  const ext = extension.toLowerCase();
  return FILE_TYPE_LABELS.get(ext) ?? ext.toUpperCase();
}
